import { PageLoading } from 'module/ui/components/atoms/loading';
import { FC } from 'react';
import { AccountSpaces } from 'components/organisms/account-spaces';
import { AccountLayout } from './common/layout';
import { AccountsTabs, AccountsTabsType } from './common/tab';
import { useCompanyFromUrl } from './use-current-company';

export const AccountSpacesPage: FC = () => {
  const { data: company, isLoading: isCompanyLoading } = useCompanyFromUrl();

  return isCompanyLoading || company == null ? (
    <PageLoading />
  ) : (
    <AccountLayout
      company={company}
      tabs={<AccountsTabs activeKey={AccountsTabsType.Spaces} />}
      content={<AccountSpaces company={company} />}
      actions={{}}
    />
  );
};
